import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { Button, Loading } from '../../root/components/common'
import { Box } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    text: {
        fontSize: 16,
        color: theme.primary,
        fontWeight: 400,
        lineHeight: 'normal',
        marginBottom: 20,
        textAlign: 'center',
        maxWidth: '80%'
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: 100,
        marginTop: 15
    },
    userDeleteRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    }
}))

export const DeleteRoleModal = ({ setOpen, onDeleteRoleClick, isLoading }) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <Box className={classes.wrapper}>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <Box component="p" className={classes.text}>
                        {locale.userManagement.deleteRoleConfirmation}
                    </Box>
                    <Box className={classes.modalButtons}>
                        <Button reverted onClick={() => setOpen(false)}>
                            {locale.common.cancel}
                        </Button>
                        <Button onClick={onDeleteRoleClick}>
                            {locale.common.delete}
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    )
}
